import React from 'react';
import { Drawer } from 'antd';
import { SearchBarProps } from '../../common/types';
import AutoCompleteSearch from '../AutoComplete';

const SearchBar: React.FC<SearchBarProps> = (Props) => {
  const placeholder = 'Search Resurants or Food...';
  return (
    <>
      <Drawer
        title="Search Items"
        placement="top"
        closable={true}
        onClose={Props.onClose}
        visible={Props.visible}
        height={'100%'}
      >
        <AutoCompleteSearch
          onClose={() => {}}
          options={[]}
          placeholder={placeholder}
        />
      </Drawer>
    </>
  );
};

export default SearchBar;
